import React from "react";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import {
  Box,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import moment from "moment";
import PaddingBoxInDesktop from "../../components/layouts/PaddingBoxDesktop";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { fetchvendorApi } from "../../apis/vendor.api";
import { StyledSearchBar } from "../../components/inputs/SearchBar";
import CustomInput from "../../components/inputs/CustomInputs";
import SubmitButton from "../../components/button/SubmitButton";
import { PRODUCTION_FG_STATUS } from "../../utils/constants";
import { titleCase } from "../../utils/main";

const InformationUI = ({
  Title,
  Data,
  TableData,
  TableTitle,
  Quantity,
  setFields,
  tableKey,
  isEdit = false,
  isProductionStartedView = false,
}) => {
  return (
    <>
      <Box sx={{ height: "auto", width: "100%", borderRadius: "10px" }}>
        {Title && (
          <Box
            p={2}
            sx={{
              borderBottom: "1px solid #1D013B",
              backgroundColor: "rgba(29, 1, 59, 0.1)",
            }}
          >
            <Typography variant="h4" color={"#1D013B"}>
              {Title}
            </Typography>
          </Box>
        )}
        {Data?.length > 0 && (
          <Grid container p={2} pt={0} md={12}>
            {Data.map(
              (item, index) =>
                !item?.isField && (
                  <React.Fragment key={index}>
                    <Grid item mt={2} md={3} xs={3} sm={3} key={index}>
                      <Typography fontWeight="bold" variant="h6">
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      mt={2}
                      md={item.IsFullLine ? 9 : 3}
                      xs={item.IsFullLine ? 9 : 3}
                      sm={item.IsFullLine ? 9 : 3}
                    >
                      <Typography
                        variant="h6"
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          color: "#808080",
                        }}
                      >
                        {item.isArray && Array.isArray(item.value)
                          ? item.value
                              .map(
                                (str) =>
                                  str.charAt(0).toUpperCase() + str.slice(1),
                              )
                              .join(", ")
                          : item.value}
                      </Typography>
                    </Grid>
                  </React.Fragment>
                ),
            )}
          </Grid>
        )}
        {TableTitle && (
          <>
            <Box
              p={2}
              sx={{ border: "1px solid rgba(0,0,0,0.2)", borderRadius: "10px" }}
            >
              <Box p={2}>
                <Typography fontWeight="bold" variant="h6">
                  {TableTitle}
                </Typography>
              </Box>
              <Card
                sx={{
                  marginBottom: 2,
                  padding: 2,
                  backgroundColor: "rgba(0, 0, 0, 0.26)",
                  color: "rgb(0 0 0 / 37%)",
                }}
              >
                <Grid container alignItems="center" spacing={5}>
                  <Grid item xs={isProductionStartedView ? 6 : 2}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      Name
                    </Typography>
                  </Grid>
                  <Grid item xs={isProductionStartedView ? 6 : 1.75}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", textAlign: "center" }}
                    >
                      {isProductionStartedView
                        ? "Total Quantity"
                        : "Total Quantity Required"}
                    </Typography>
                  </Grid>
                  {!isProductionStartedView && (
                    <Grid item xs={1.75}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Current Quantity
                      </Typography>
                    </Grid>
                  )}
                  {!isProductionStartedView && (
                    <Grid item xs={1.75}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Quantity Difference
                      </Typography>
                    </Grid>
                  )}
                  {/* {!isProductionStartedView && (
                    <Grid item xs={2}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Status
                      </Typography>
                    </Grid>
                  )} */}
                  {!isProductionStartedView && (
                    <Grid item xs={2.75}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Vendor Name
                      </Typography>
                    </Grid>
                  )}
                  {!isProductionStartedView && (
                    <Grid item xs={2}>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", textAlign: "center" }}
                      >
                        Total Time
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Card>
              {(TableData || []).map((item, index) => {
                return (
                  <Card key={index} sx={{ marginBottom: 2, padding: 2 }}>
                    <Grid container alignItems="center" spacing={5}>
                      <Grid
                        item
                        xs={isProductionStartedView ? 6 : 2}
                        sx={{ textAlign: "center" }}
                      >
                        <Typography variant="body2">{item.name}</Typography>
                      </Grid>
                      <Grid
                        item
                        xs={isProductionStartedView ? 6 : 1.75}
                        sx={{ textAlign: "center" }}
                      >
                        <Typography variant="body2">
                          {Number(item?.min_of_quantity || 0) *
                            Number(Quantity || 0)}
                        </Typography>
                      </Grid>
                      {!isProductionStartedView && (
                        <Grid item xs={1.75} sx={{ textAlign: "center" }}>
                          <Typography variant="body2">
                            {item.currentStock}
                          </Typography>
                        </Grid>
                      )}
                      {!isProductionStartedView && (
                        <Grid item xs={1.75} sx={{ textAlign: "center" }}>
                          <Typography
                            variant="body2"
                            backgroundColor={
                              item?.difference < 0
                                ? "#fa4b4b70"
                                : "rgb(63 243 167 / 41%)"
                            }
                            borderRadius={"10px"}
                            border={
                              item?.difference < 0
                                ? "2px solid #fa4b4b70"
                                : "2px solid rgb(63 243 167 / 41%)"
                            }
                            color={
                              item?.difference < 0 ? "#d32f2fd6" : "#00100782"
                            }
                          >
                            {item?.difference}
                          </Typography>
                        </Grid>
                      )}
                      {/* {!isProductionStartedView && (
                        <Grid item xs={2} sx={{ textAlign: "center" }}>
                          <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select
                              disabled={true}
                              value={item.status}
                              label="Status*"
                              onChange={(e) => {
                                const updatedstatus = [...TableData];
                                updatedstatus[index] = {
                                  ...updatedstatus[index],
                                  status: e.target.value,
                                };
                                setFields((prev) => ({
                                  ...prev,
                                  err: "",
                                  [tableKey]: updatedstatus,
                                }));
                              }}
                            >
                              {Object.keys(MATERIAL_STAGES).map((key) => (
                                <MenuItem
                                  key={key}
                                  value={MATERIAL_STAGES[key]}
                                >
                                  {titleCase(key)}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                      )} */}
                      {!isProductionStartedView && (
                        <Grid item xs={2.75} sx={{ textAlign: "center" }}>
                          <PaddingBoxInDesktop
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <AsyncDropDown
                              Value={
                                item.vendor && item.vendor_name
                                  ? {
                                      _id: item.vendor,
                                      name: item.vendor_name,
                                    }
                                  : null
                              }
                              lazyFun={async (para) =>
                                await fetchvendorApi({
                                  ...para,
                                  allStatus: true,
                                  tableKey,
                                  id: item?._id,
                                })
                              }
                              OptionComponent={({ option, ...rest }) => (
                                <ListItem {...rest}>{option.name}</ListItem>
                              )}
                              onChange={async (changedVal) => {
                                const TypeOfId = (tableKey) => {
                                  switch (tableKey) {
                                    case "sfgs":
                                      return "sfgId";
                                    case "skds":
                                      return "skdId";
                                    default:
                                      return "rawMaterialId";
                                  }
                                };
                                const key = TypeOfId(tableKey);
                                const data = changedVal?.[tableKey]?.find(
                                  (obj) => obj?.[key] === item?._id,
                                );
                                console.log(" data fetch", data);
                                const updatedstatus = [...TableData];
                                updatedstatus[index] = {
                                  ...updatedstatus[index],
                                  vendor: changedVal ? changedVal?._id : null,
                                  vendor_name: changedVal
                                    ? changedVal?.name
                                    : null,
                                  lead_time: Number(data?.lead_time ?? 0),
                                };
                                setFields((prev) => ({
                                  ...prev,
                                  err: "",
                                  [tableKey]: updatedstatus,
                                }));
                              }}
                              titleKey={"name"}
                              valueKey={"_id"}
                              InputComponent={(params) => (
                                <StyledSearchBar
                                  label={"Select Vendor"}
                                  placeholder={"Select Vendor"}
                                  {...params}
                                  margin="none"
                                />
                              )}
                            />
                          </PaddingBoxInDesktop>
                        </Grid>
                      )}
                      {!isProductionStartedView && (
                        <Grid item xs={2} sx={{ textAlign: "center" }}>
                          <Typography variant="body2">
                            {item?.difference < 0
                              ? `${Number(item?.lead_time) || 0} ${Number(item?.lead_time) === 1 ? "Day" : "Days"}`
                              : "Stock Available"}
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                  </Card>
                );
              })}
              {(!TableData || TableData.length === 0) && (
                <Card sx={{ marginBottom: 2, padding: 2 }}>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "center", color: "text.secondary" }}
                  >
                    No records
                  </Typography>
                </Card>
              )}
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

const CreateProductionPlanUi = ({
  onSubmit,
  loading,
  fields,
  quantity,
  setFields,
  isview,
  isEdit = false,
  canStartProduction = false,
  isProductionStartedView = false,
  progressEntryQty,
  setProgressEntryQty,
  fgStatus,
  setFgStatus,
  productionProgressSummary,
  fgStatusSummary,
  reworkableToPassedQty,
  setReworkableToPassedQty,
  convertingStatus,
  onConvertReworkableToPass,
  reworkableToRejectedQty,
  setReworkableToRejectedQty,
  convertingToRejectedStatus,
  onConvertReworkableToRejected,
  recordingProduction = false,
  onRecordProduction,
}) => {
  const getModalId = () => {
    if (isEdit) return "Production-Planning-Edit";
    if (isview) return "Production-Planning-View";
    return "Production-Planning";
  };

  // Get button text and properties
  const getButtonText = () => {
    if (!isEdit) return "Create Plan";
    return isProductionStartedView ? "Finish Production" : "Start Production";
  };

  // Get button disabled state
  const getButtonDisabled = () => {
    if (!isEdit) return false;
    if (isProductionStartedView) return false;
    return !canStartProduction;
  };

  const hasFgStatusSummary =
    Number(fgStatusSummary?.passedQty || 0) > 0 ||
    Number(fgStatusSummary?.reworkableQty || 0) > 0 ||
    Number(fgStatusSummary?.rejectedQty || 0) > 0;
  return (
    <CustomDialog
      id={getModalId()}
      loading={loading}
      err={fields.err}
      disabled={getButtonDisabled()}
      onSubmit={isview ? undefined : onSubmit}
      title={isEdit ? "Production Started" : "Production Planning"}
      closeText="Close"
      confirmText={getButtonText()}
      disabledSubmit={getButtonDisabled()}
    >
      <Box>
        <InformationUI
          Data={[
            { label: "Create Date :", value: moment().format("DD-MM-YYYY") },
            {
              label: "Product Name :",
              value: fields?.name ? fields?.name : "NA",
            },
            {
              label: "Planned Quantity :",
              value: quantity ?? "NA",
            },
            {
              label: "Fg Code :",
              value: fields?.fg_Code ? fields?.fg_Code : "NA",
            },
          ]}
        />
        <Box mb={2}>
          <InformationUI
            TableTitle={"Semi Finished Good"}
            Quantity={quantity}
            TableData={fields?.sfgs}
            setFields={setFields}
            tableKey="sfgs"
            isEdit={isEdit}
            isProductionStartedView={isProductionStartedView}
          />
        </Box>
        <Box mb={2}>
          <InformationUI
            TableTitle={"Semi Knocked Down"}
            Quantity={quantity}
            TableData={fields?.skds}
            setFields={setFields}
            tableKey="skds"
            isEdit={isEdit}
            isProductionStartedView={isProductionStartedView}
          />
        </Box>
        <Box mb={2}>
          <InformationUI
            TableTitle={"Raw Materials"}
            Quantity={quantity}
            TableData={fields?.rawMaterials}
            setFields={setFields}
            tableKey="rawMaterials"
            isEdit={isEdit}
            isProductionStartedView={isProductionStartedView}
          />
        </Box>
        {isEdit && isProductionStartedView && (
          <Box
            mb={2}
            p={2}
            sx={{ border: "1px solid rgba(0,0,0,0.2)", borderRadius: "10px" }}
          >
            <Typography fontWeight="bold" variant="h6" mb={2}>
              Production Progress
            </Typography>

            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={3}>
                <Typography variant="body2" color="textSecondary">
                  Planned FG
                </Typography>
                <Typography variant="h6">
                  {productionProgressSummary?.plannedFgQty || 0}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="body2" color="textSecondary">
                  Produced FG
                </Typography>
                <Typography variant="h6">
                  {productionProgressSummary?.producedFgQty || 0}
                </Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Typography variant="body2" color="textSecondary">
                  Remaining FG
                </Typography>
                <Typography variant="h6">
                  {productionProgressSummary?.remainingFgQty || 0}
                </Typography>
              </Grid>
              {hasFgStatusSummary && (
                <Grid item xs={12}>
                  <Card
                    sx={{
                      p: 2,
                      backgroundColor: "rgba(29, 1, 59, 0.04)",
                      border: "1px solid rgba(29, 1, 59, 0.12)",
                    }}
                  >
                    <Typography fontWeight="bold" variant="subtitle1" mb={2}>
                      FG Status Summary
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body2" color="textSecondary">
                          Passed
                        </Typography>
                        <Typography variant="h6">
                          {fgStatusSummary?.passedQty ?? 0}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body2" color="textSecondary">
                          Reworkable
                        </Typography>
                        <Typography variant="h6">
                          {fgStatusSummary?.reworkableQty ?? 0}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <Typography variant="body2" color="textSecondary">
                          Rejected
                        </Typography>
                        <Typography variant="h6">
                          {fgStatusSummary?.rejectedQty ?? 0}
                        </Typography>
                      </Grid>
                    </Grid>
                    {Number(fgStatusSummary?.reworkableQty || 0) > 0 && (
                      <Box
                        mt={3}
                        pt={2}
                        sx={{ borderTop: "1px solid rgba(0,0,0,0.1)" }}
                      >
                        <Typography
                          fontWeight="bold"
                          variant="subtitle2"
                          mb={2}
                        >
                          Convert Reworkable to Passed
                        </Typography>
                        <Grid container spacing={2} alignItems="flex-start">
                          <Grid item xs={12} md={4}>
                            <CustomInput
                              type="number"
                              label="Quantity to Convert"
                              placeholder="Enter quantity"
                              value={reworkableToPassedQty}
                              onChange={(e) =>
                                setReworkableToPassedQty(e.target.value)
                              }
                              disabled={convertingStatus}
                              inputProps={{
                                min: 0,
                                max: fgStatusSummary?.reworkableQty || 0,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <SubmitButton
                              title="Convert to Passed"
                              loading={convertingStatus}
                              onClick={onConvertReworkableToPass}
                              disabled={
                                convertingStatus ||
                                !reworkableToPassedQty ||
                                Number(reworkableToPassedQty) === 0
                              }
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </Card>
                </Grid>
              )}
              {Number(fgStatusSummary?.reworkableQty || 0) > 0 && (
                <Grid item xs={12} md={6}>
                  <Card sx={{ p: 3 }}>
                    <Grid container spacing={2} alignItems="flex-start">
                      <Grid item xs={12}>
                        <Typography
                          fontWeight="bold"
                          variant="subtitle2"
                          mb={2}
                        >
                          Convert Reworkable to Rejected
                        </Typography>
                        <Grid container spacing={2} alignItems="flex-start">
                          <Grid item xs={12} md={4}>
                            <CustomInput
                              type="number"
                              label="Quantity to Convert"
                              placeholder="Enter quantity"
                              value={reworkableToRejectedQty}
                              onChange={(e) =>
                                setReworkableToRejectedQty(e.target.value)
                              }
                              disabled={convertingToRejectedStatus}
                              inputProps={{
                                min: 0,
                                max: fgStatusSummary?.reworkableQty || 0,
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4}>
                            <SubmitButton
                              title="Convert to Rejected"
                              loading={convertingToRejectedStatus}
                              onClick={onConvertReworkableToRejected}
                              disabled={
                                convertingToRejectedStatus ||
                                !reworkableToRejectedQty ||
                                Number(reworkableToRejectedQty) === 0
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              )}
              <Grid item xs={12} md={3}>
                <CustomInput
                  type="number"
                  label="Add FG Quantity"
                  placeholder="Enter quantity"
                  value={progressEntryQty}
                  onChange={(e) => setProgressEntryQty(e.target.value)}
                  disabled={recordingProduction}
                  inputProps={{ min: 0 }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl fullWidth>
                  <InputLabel id="fg-status-label">FG Status*</InputLabel>
                  <Select
                    labelId="fg-status-label"
                    value={fgStatus}
                    label="FG Status*"
                    onChange={(e) => setFgStatus(e.target.value)}
                    disabled={recordingProduction}
                  >
                    {Object.entries(PRODUCTION_FG_STATUS).map(
                      ([key, value]) => (
                        <MenuItem key={key} value={value}>
                          {titleCase(key)}
                        </MenuItem>
                      ),
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Box mt={2} mb={2}>
              <SubmitButton
                title="Record Production"
                loading={recordingProduction}
                onClick={onRecordProduction}
                disabled={
                  recordingProduction ||
                  !productionProgressSummary?.remainingFgQty
                }
              />
            </Box>

            <Divider sx={{ mb: 2 }} />

            {(productionProgressSummary?.groups || []).map((group) => (
              <Box key={group.key} mb={2}>
                <Typography fontWeight="bold" variant="subtitle1" mb={1}>
                  {group.title}
                </Typography>
                <Card
                  sx={{ p: 2, mb: 1, backgroundColor: "rgba(0, 0, 0, 0.04)" }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Typography fontWeight="bold" variant="body2">
                        Name
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography fontWeight="bold" variant="body2">
                        Total Required
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography fontWeight="bold" variant="body2">
                        Consumed
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography fontWeight="bold" variant="body2">
                        Required Remaining
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography fontWeight="bold" variant="body2">
                        Assembly Available
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>

                {(group.items || []).map((item) => (
                  <Card key={item.id || item.name} sx={{ p: 2, mb: 1 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={3}>
                        <Typography variant="body2">{item.name}</Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body2">
                          {item.totalRequiredQty}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body2">
                          {item.consumedQty}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography variant="body2">
                          {item.remainingQty}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography variant="body2">
                          {item.assemblyAvailableQty}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                ))}
              </Box>
            ))}
          </Box>
        )}
      </Box>
    </CustomDialog>
  );
};

export default CreateProductionPlanUi;
